import React from 'react';
import { useTranslation } from 'react-i18next';

import { FitnessApplicationActivityType } from '../../../types/__generated__';
import config from '../../client/config';
import useFitnessAuth from '../../hooks/fitness/useFitnessAuth';
import { FitnessManager } from './FitnessManager';

import styles from './FitnessManager.scss';

export function StravaManager() {
  const { t } = useTranslation('common', { useSuspense: false });

  return (
    <FitnessManager
      fitnessApplicationName="strava"
      text={{
        paused: {
          status: t('fitnessSection.strava.status.paused'),
          description: t('fitnessSection.strava.description.paused'),
        },
        connected: {
          status: t('fitnessSection.strava.status.connected'),
          description: t('fitnessSection.strava.description.connected'),
        },
        disconnected: {
          status: '',
          description: t('fitnessSection.strava.description.notConnected'),
        },
      }}
      url={{
        compliance:
          'https://help.justgiving.com/hc/en-us/articles/360019657217-Use-of-Your-Strava-Data',
      }}
    >
      <FitnessManager.FitnessLogo>
        <FitnessManager.FitnessLogo.Strava />
      </FitnessManager.FitnessLogo>
      <FitnessManager.ActivityTotals
        showFilterButtons={true}
        showOverallCompleted={true}
      />
      <FitnessManager.SettingsButton
        text={t('strava.settingsButton')}
        className={styles.stravaButton}
      />
      <FitnessManager.ConnectButton
        text={t('strava.connectButton')}
        className={styles.stravaButton}
        onClick={useFitnessAuth(config.strava)}
      />
      <FitnessManager.AddManualActivityButton
        text={t('fitness.addManualActivity')}
        className={styles.button}
      />
      <FitnessManager.Settings>
        <FitnessManager.Settings.ActivityTypes />
        <FitnessManager.Settings.UnitsOfMeasurement />
        <FitnessManager.Settings.DisplayPreferences>
          <FitnessManager.Settings.DisplayPreferences.ShowDistance />
          <FitnessManager.Settings.DisplayPreferences.ShowDuration />
          <FitnessManager.Settings.DisplayPreferences.ShowElevation />
          <FitnessManager.Settings.DisplayPreferences.ShowPhotos />
          <FitnessManager.Settings.DisplayPreferences.ShowMap />
          <FitnessManager.Settings.DisplayPreferences.ShowTotaliser />
        </FitnessManager.Settings.DisplayPreferences>
      </FitnessManager.Settings>
      <FitnessManager.AddManualActivity
        title={t('manualFitness.modalTitle.strava')}
        activities={Object.values(FitnessApplicationActivityType)}
      >
        <FitnessManager.AddManualActivity.DatePicker />
        <FitnessManager.AddManualActivity.ActivityTypes />
        <FitnessManager.AddManualActivity.Distance />
        <FitnessManager.AddManualActivity.Elevation />
        <FitnessManager.AddManualActivity.Duration />
        <FitnessManager.AddManualActivity.Title />
        <FitnessManager.AddManualActivity.Story />
        <FitnessManager.AddManualActivity.ImageUpload />
      </FitnessManager.AddManualActivity>
    </FitnessManager>
  );
}
